import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const CompanyTitle = () => {
    return (
        <p><span className='fw_bold'>미래</span>를 선도하는 <br className='lineBreak' />차세대 <span className='fw_bold'>IT 기술력</span>으로 <br className='lineBreak pc' /><span className='fw_bold'>고객의 비즈니스 성공</span>을 <br className='lineBreak' />만들어갑니다</p>
    )
}

const BusinessTitle = () => {
    return (
        <p><span className='fw_bold'>축적된 노하우</span>와 <br className='lineBreak' />차세대 <span className='fw_bold'>IT 기술</span>을 바탕으로 <br className='lineBreak pc' /><span className='fw_bold'>고객의 비즈니스 성공</span>을 <br className='lineBreak' />지원합니다</p>
    )
}

const ResearchTitle = () => {
    return (
        <p>혁신적이고 더 나은 미래를 <br className='lineBreak' />만들기 위해 <span className='fw_bold'>핵심기술</span> 및<br className='lineBreak pc' />비즈니스 <span className='fw_bold'> 지원도구를</span> <br className='lineBreak' /><span className='fw_bold'>연구 개발</span>하고 있습니다</p>
    )
}

const HeadTitle = ({ page }) => {

    useEffect(() => {
        AOS.init({
            duration: 1000
        });
    });


    /**
     * page 를 입력받아, 해당하는 component 를 반환하는 함수
     * @param {string} page string 타입의 page
     * @returns page 에 해당하는 component 를 반환
     */
    const switchHeadTitle = (page) => {
        switch (page) {
            case "company":
                return <CompanyTitle />
            case "business":
                return <BusinessTitle />
            case "research":
                return <ResearchTitle />
            default: return;

        }
    }

    return (
        <section className='HeadTitle' data-aos='zoom-in'>
            {switchHeadTitle(page)}
        </section>
    );
};

export default HeadTitle;